import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from './auth.service';

/**
 * This directive can be used to toggle any UI element visible or hidden based on user's permissions.
 */
@Directive({selector: '[qmAuth]'})
export class AuthDirective {

  /**
   * Default constructor
   * @param {TemplateRef<any>} templateRef
   * @param {ViewContainerRef} viewContainer
   * @param {AuthService} authService
   */
  constructor(private templateRef: TemplateRef<any>,
              private viewContainer: ViewContainerRef,
              private authService: AuthService) {
  }

  /**
   * Actual directive, AuthService is used to determine whether UI element is displayed or not.
   * @param {string} permission
   */
  @Input()
  set qmAuth(permission: string) {
    const authorized = this.authService.hasPermission(permission);
    if (authorized) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
